import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function scrollAnimation() {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 870px)", () => {
        let panels = gsap.utils.toArray("[data-item]", document);
        let tops = panels.map(panel => ScrollTrigger.create({trigger: panel, start: "top 200px"}));

        panels.forEach((panel, i) => {
        ScrollTrigger.create({
            trigger: panel,
            start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", 
            pin: true, 
            pinSpacing: false,
            // markers: true
        });
        });

        // ScrollTrigger.create({
        // snap: {
        //     snapTo: (progress, self) => {
        //     let panelStarts = tops.map(st => st.start), 
        //         snapScroll = gsap.utils.snap(panelStarts, self.scroll()); 
        //     return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll); 
        //     },
        //     duration: 0.5
        // }
        // });
    });
}